import 'core-js/stable'

import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'

import { version } from '../package.json'
import { detect } from 'detect-browser'

import store from './store'
import App from 'pages/index'

import registerServiceWorker from './registerServiceWorker'

import './index.scss'
import './auth.scss'

import { getEnvName } from 'config/env.js'

console.info(`illumiQuote@${version}, env: ${getEnvName()}`)

window.LOG_LEVEL = ['development', 'local'].includes(getEnvName())
  ? 'DEBUG'
  : 'WARN'

render(
  <Provider store={store}>
    <App version={version} browser={detect()} />
  </Provider>,
  document.querySelector('#root'),
)

registerServiceWorker()

document.addEventListener('touchend', () => {})
